(function () {
  // Dawn's SlideshowComponent loops from the last slide back to the first
  // by calling slider.scrollTo({left: 0}) - with the slider's own
  // scroll-behavior:smooth CSS, that plays as one long smooth scroll
  // backwards through every slide in between instead of a clean cut from
  // the last slide straight to the first. Patch it to jump instantly
  // only for that specific wrap-around case; every other transition
  // (next/prev between adjacent slides) keeps its normal smooth scroll.
  function patch() {
    if (typeof SlideshowComponent === 'undefined') return;
    var proto = SlideshowComponent.prototype;
    if (proto.__lusheLoopFixApplied) return;
    proto.__lusheLoopFixApplied = true;

    var originalSetSlidePosition = proto.setSlidePosition;

    proto.setSlidePosition = function (position) {
      var isLastSlide = this.currentPage === this.sliderItems.length;
      var isWrappingToStart = position === 0 && isLastSlide && this.slider.scrollLeft > 0;

      if (!isWrappingToStart) {
        originalSetSlidePosition.call(this, position);
        return;
      }

      if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
      var slider = this.slider;
      this.setPositionTimeout = setTimeout(function () {
        var previousBehavior = slider.style.scrollBehavior;
        slider.style.scrollBehavior = 'auto';
        slider.scrollTo({ left: position });
        requestAnimationFrame(function () {
          slider.style.scrollBehavior = previousBehavior || '';
        });
      }, this.announcerBarAnimationDelay);
    };
  }

  document.addEventListener('DOMContentLoaded', patch);
})();
